import React, { useState } from 'react';
import { Instagram, Mail } from 'lucide-react';
import BloomAttributionTab from './BloomAttributionTab';
import { GiveawayWorkspace } from './GiveawayWorkspace';

export const SocialAttributionTab = () => {
  const [view, setView] = useState('instagram');
  return <div data-testid="social-attribution-extension">
    <div className="flex flex-wrap gap-2 mb-6 border-b border-navy/15 pb-4" role="tablist" aria-label="Social attribution views">
      {[['instagram', 'Instagram activity', Instagram], ['email', 'Email sign-ups', Mail]].map(([id, label, Icon]) => <button key={id} role="tab" aria-selected={view === id} onClick={() => setView(id)} className={`inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold ${view === id ? 'bg-navy text-white' : 'bg-white text-navy border border-navy/20'}`} data-testid={`social-attribution-${id}-tab`}><Icon size={16} />{label}</button>)}
    </div>
    {view === 'instagram' ? <BloomAttributionTab /> : <GiveawayWorkspace />}
  </div>;
};